import { useState, useEffect, useMemo } from "react";
import { addressGetList } from "../../../services/address";
import { getContainersList } from "../../../services/container";
import { getUserData } from "../../../services/users";
import { getCampaigns } from "../../../services/notification";

const ADDRESS_LIST_PAGE = 1;
const ADDRESS_LIST_LIMIT = 100;

export const useCampaignData = (periodStart, periodStop) => {
  const user = useMemo(() => {
    try {
      const stored = localStorage.getItem("user");
      if (!stored) return null;
      const { token, ...userData } = JSON.parse(stored);
      return userData;
    } catch (error) {
      console.error("Error parsing user data:", error);
      return null;
    }
  }, []);

  const [addressList, setAddressList] = useState([]);
  const [containerList, setContainerList] = useState([]);
  const [campaignPeriods, setCampaignPeriods] = useState([]);
  const [isLoadingCampaignPeriods, setIsLoadingCampaignPeriods] =
    useState(true);

  const fetchAddress = async () => {
    if (!user?._id) {
      console.warn("No user ID available");
      return;
    }

    try {
      const params = {
        keywordFilter: "",
        listPostalCodeFilter: {},
        listCityFilter: {},
        sortByField: "name",
        orderSortByField: "1",
        listRoleFilter: {},
      };

      const response = await addressGetList(
        params,
        ADDRESS_LIST_PAGE,
        ADDRESS_LIST_LIMIT,
      );
      const userData = await getUserData(user._id);

      const authorizedAddresses = userData.data.user?.authorizedAddresses || [];

      const filteredAddresses = response.data.data.filter((addr) =>
        authorizedAddresses.includes(addr._id.toString()),
      );

      setAddressList(filteredAddresses);
    } catch (error) {
      console.error("Error fetching addresses:", error);
      setAddressList([]);
    }
  };

  const fetchCampaignsPeriods = async () => {
    setIsLoadingCampaignPeriods(true);
    try {
      const response = await getCampaigns({
        start: periodStart,
        stop: periodStop,
      });
      setCampaignPeriods(response.data.campaigns);
    } catch (error) {
      console.error("Error fetching campaign periods:", error);
      setCampaignPeriods([]);
    } finally {
      setIsLoadingCampaignPeriods(false);
    }
  };

  const fetchContainers = async () => {
    try {
      const response = await getContainersList({
        page: null,
        limit: null,
        fieldSort: "filling_level",
        orderSort: "-1",
        typeFillingFilter: "all",
      });
      setContainerList(response.data.data);
    } catch (error) {
      console.error("Error fetching containers:", error);
      setContainerList([]);
    }
  };

  useEffect(() => {
    fetchAddress();
    fetchCampaignsPeriods();
    fetchContainers();
    // eslint-disable-next-line
  }, [periodStart, periodStop, user]);

  const filterContainerByAddress = (addressId) => {
    return containerList.filter(
      (item) => item.addressId?.toString() === addressId?.toString(),
    );
  };

  return {
    addressList,
    containerList,
    campaignPeriods,
    isLoadingCampaignPeriods,
    setCampaignPeriods,
    filterContainerByAddress,
    fetchCampaignsPeriods,
  };
};
